module.exports = __webpack_public_path__ + "img/export-csv-file.2a8c39a6.png";